<script setup>

import Button from "primevue/button";
import ConfirmDialog from "primevue/confirmdialog";
import Popover from "primevue/popover";
import Textarea from "primevue/textarea";
import {ref} from "vue";

const notificationMessage = defineModel();
const doSend = defineModel('doSend');
const help = ref();
</script>

<template>
    <Popover ref="help">
        <p class=" text-gray-600 dark:text-gray-400 max-w-sm leading-relaxed">
            {{ $t('reservations.msg_dialog_help') }}
        </p>
    </Popover>
    <ConfirmDialog group="confirmation-dialog">
        <template #container="{ acceptCallback, rejectCallback }">
            <div class="flex flex-col items-center p-6 bg-white dark:bg-gray-900 rounded-lg shadow-lg w-full max-w-lg">
                <div class="flex items-center justify-between gap-4">
                    <p class="w-full text-lg font-medium text-left text-gray-900 dark:text-gray-100">
                        {{ $t('reservations.msg_dialog_title') }}
                    </p>
                    <div class="grow"></div>
                    <Button
                        icon="pi pi-question-circle"
                        text
                        @click="($event) => help.toggle($event)"
                        rounded
                        severity="contrast"
                    ></Button>
                </div>

                <Textarea
                    class="w-full mt-4 p-3 border rounded-md text-sm dark:bg-gray-800 dark:border-gray-700 dark:text-white"
                    :placeholder="$t('reservations.msg_dialog_placeholder')"
                    v-model="notificationMessage"
                    rows="3"
                ></Textarea>

                <div class="flex justify-end gap-3 mt-6 w-full">
                    <Button
                        :label="$t('common.cancel')"
                        text
                        severity="secondary"
                        @click="() => {
                            rejectCallback();
                        }"
                    ></Button>

                    <Button
                        :label="$t('reservations.msg_dialog_just_change')"
                        outlined
                        severity="secondary"
                        @click="() => {
                            acceptCallback();
                        }"
                    ></Button>

                    <Button
                        :label="$t('common.send')"
                        class="text-white"
                        :disabled="notificationMessage === ''"
                        severity="primary"
                        @click="() => {
                            doSend = true;
                            acceptCallback();
                        }"
                    ></Button>
                </div>

                <!-- Info text -->

            </div>
        </template>
    </ConfirmDialog>
</template>

<style scoped lang="scss">

</style>
